import Label from "@coworker/apprestructured/src/task-management/components/TaskCard/components/Label/Label";
import { Loading } from "@coworker/apprestructured/src/task-management/loading";

type DateProps = {
  value: string | Loading;
};

function Date({ value }: DateProps) {
  return <Label value={value} />;
}

export default Date;
